import { getDefaultUserState } from '../user/index';
import userStoreMutations from '@constans/store/user/userStoreMutations';
const mutations = {
    [userStoreMutations.SET_USER]: (state, user) => {
        Object.assign(state, user);
        if (typeof user.roles[0] === 'undefined') {
            state.user_role = '';
        }
        else {
            state.user_role = user.roles[0];
        }
        if (user && !user.contact_person) {
            user.contact_person = {
                first_name: '',
                last_name: '',
                email: '',
                cellphone: ''
            };
        }
    },
    [userStoreMutations.CLEAR_USER]: (state) => Object.assign(state, getDefaultUserState()),
    [userStoreMutations.CHANGE_STATE]: (state, field) => {
        Object.keys(field).forEach(key => {
            const currentState = field.base !== undefined ? state[field.base] : state;
            // Do not save the "key base" in state.
            if (key !== 'base') {
                currentState[key] = field[key];
            }
        });
    },
    [userStoreMutations.CHANGE_CONTACT_PERSON_STATE]: (state, field) => {
        const key = Object.keys(field)[0];
        if (state.contact_person) {
            state.contact_person[key] = field[key];
        }
    }
};
export default mutations;
